module.exports = __webpack_public_path__ + "static/media/icon_file.98716258.svg";